<template>
  <section class="p-6 pb-14 text-center speak-with-us">
    <h4 class="mb-2 mt-6">
      Want to create your personalised ocean experience?
    </h4>
    <p class="mb-6">
      Get in touch with our expert travel team and plan your next dive trip
    </p>

    <div class="lg:hidden flex justify-center">
      <img
        class="mb-8"
        src="/img/team_image_2024.png"
        alt="ZuBlu Expert Travel Team"
        width="280px"
      />
    </div>

    <div class="inline-flex gap-4 sm:flex-col sm:w-full">
      <a href="/enquiry" class="inline-block sm:w-full">
        <button
          type="button"
          class="btn btn-primary flex items-center sm:w-full sm:justify-center"
        >
          <svg width="24" height="24" class="fill-white mr-2">
            <use xlink:href="/img/sprite.svg#ic_send"></use>
          </svg>
          Send enquiry
        </button>
      </a>

      <trengo-link>
        <template v-slot="{ openChat }">
          <button
            type="button"
            class="btn btn-primary btn-outlined flex items-center sm:justify-center"
            @click="openChat()"
          >
            <svg width="24" height="24" class="fill-current mr-2">
              <use xlink:href="/img/sprite.svg#ic_chat"></use>
            </svg>
            Chat with us
          </button>
        </template>
      </trengo-link>
    </div>
  </section>
</template>

<script>
import TrengoLink from "../core/TrengoLink";

export default {
  components: {
    TrengoLink,
  },
};
</script>

<style scoped>
.speak-with-us {
  border-top: 1px solid var(--border-primary);
  border-bottom: 1px solid var(--border-primary);
}
</style>
